import { render } from "./header-border.vue?vue&type=template&id=191a996e"
import script from "./header-border.vue?vue&type=script&lang=js"
export * from "./header-border.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__